import { setErrorPlacementDefault, SimpleFooter, SkipNav, setHelpDrawerSendsAnalytics } from '@cmsgov/ds-medicare-gov';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { useState } from 'react';
import { Redirect, Route, Switch, useLocation } from 'react-router-dom';
import setLanguage from './common/functions/setLanguage';
import translate from './common/functions/translate';
import CreateAccount from './create-account/components/CreateAccount';
import FindMyAccount from './find-my-account/components/FindMyAccount';
import ForgotPassword from './forgot-password/components/ForgotPassword';
import ForgotUsernameAndPassword from './forgot-username-and-password/components/ForgotUsernameAndPassword';
import ForgotUsername from './forgot-username/components/ForgotUsername';
import Login from './login/components/Login';
import UnlockAccount from './unlock-account/components/UnlockAccount';
import { redirectFromSpanishSite } from './common/functions/redirectFromSpanishSite';
import { defaultMfaLoginData, GlobalDataProvider } from './globalContext';
import { GlobalHeader } from './GlobalHeader';
import SessionTimeout from './SessionTimeout';
import { SecurityCode } from './mfa/SecurityCode';
import { Footer } from './common/components/Footer';

interface AppProps {
    /** useful for Storybook/unit tests where we don't want to attempt loading the global header */
    noGlobalHeader?: boolean
}

export default function App(props: AppProps) {
    setErrorPlacementDefault('bottom');
    setHelpDrawerSendsAnalytics(true);
    redirectFromSpanishSite();

    const location = useLocation();
    const { globalHeaderLiveChat } = useFlags();

    const [showNewAccountLoginAlert, setShowNewAccountLoginAlert] = useState(false);
    const [mfaLoginData, setMfaLoginData] = useState(defaultMfaLoginData());
    const [enableHeaderTimeout, setEnableHeaderTimeout] = useState(false);

    return <>
        <SkipNav href="#main">
            {translate('skip_main_content')}
        </SkipNav>
        {!props.noGlobalHeader &&
            <GlobalHeader
                enableLiveChat={globalHeaderLiveChat}
                enableTimeout={enableHeaderTimeout}
            />
        }

        <GlobalDataProvider value={{
            enableHeaderTimeout,
            setEnableHeaderTimeout,
            showNewAccountLoginAlert,
            setShowNewAccountLoginAlert,
            mfaLoginData,
            setMfaLoginData
        }}>
            {!enableHeaderTimeout && <SessionTimeout />}
            <main id="main">
                <div
                    id={'App'}
                    style={{minHeight: 600}}
                >
                    <Switch location={location}>
                        <Route
                            exact={true}
                            path={'/'}
                        >
                            <Redirect to={'/login'}/>
                        </Route>
                        <Route
                            component={CreateAccount}
                            exact={true}
                            path={'/create-account'}
                        />
                        <Route
                            component={FindMyAccount}
                            path={'/find-my-account'}
                        />
                        <Route
                            component={ForgotPassword}
                            exact={true}
                            path={'/forgot-password'}
                        />
                        <Route
                            component={ForgotUsername}
                            exact={true}
                            path={'/forgot-username'}
                        />
                        <Route
                            component={ForgotUsernameAndPassword}
                            exact={true}
                            path={'/forgot-username-and-password'}
                        />
                        <Route
                            component={Login}
                            path={'/login'}
                        />
                        <Route
                            path={'/logout'}
                        >
                            <Redirect
                                to={{
                                    pathname: '/login',
                                    state: { logout: true }
                                }}
                            />
                        </Route>
                        <Route
                            component={UnlockAccount}
                            path={'/unlock-account'}
                        />
                        <Route path={'/security-code'}>
                            <SecurityCode />
                        </Route>
                        <Route>
                            <Redirect to={'/login'}/>
                        </Route>
                    </Switch>
                </div>
            </main>
        </GlobalDataProvider>
        <Footer />
    </>
}
